import orderBy from "lodash/orderBy";
import { formatNumber } from "../misc/utils";
import type { Cost } from "./costTypes";
import { calculateMargin, costInvoiceAmountInOrderCurrency, costStatusToName } from "./costsUtils";
import { formatDate } from "../data/dataUtils";

const headers = [
  "Numer rezerwacji",
  "Status rezerwacji",
  "Nazwa zamówienia",
  "Data",
  "Klient",
  "Dostawca",
  "Numer faktury",
  "Data faktury",
  "Do zapłaty",
  "Waluta",
  "Kurs waluty",
  "Do zapłaty w walucie zamówienia",
  "Cena dla klienta",
  "Waluta zamówienia",
  "Marża (%)",
  "Notatki",
];

function costCsvRows(cost: Omit<Cost, "files">) {
  if (cost.invoices.length === 0) {
    return [
      [
        cost.bookingNumber,
        costStatusToName(cost.status),
        cost.order.name,
        formatDate(cost.date),
        cost.customer.name,
        cost.provider.name,
        undefined,
        undefined,
        undefined,
        cost.currency,
        undefined,
        undefined,
        cost.order.price,
        cost.order.currency,
        calculateMargin(cost.order.price, cost.order.currency, cost.currency, cost.invoices),
        cost.notes.map((n) => `${n.date}: ${n.text} (${n.author})`).join("\n"),
      ],
    ];
  }
  return cost.invoices.map((invoice) => [
    cost.bookingNumber,
    costStatusToName(cost.status),
    cost.order.name,
    formatDate(cost.date),
    cost.customer.name,
    cost.provider.name,
    invoice.invoiceNumber,
    invoice.date ? formatDate(invoice.date) : undefined,
    formatNumber(invoice.amount),
    cost.currency,
    invoice.exchangeRate,
    formatNumber(
      costInvoiceAmountInOrderCurrency(
        cost.order.currency,
        invoice.amount ?? null,
        cost.currency,
        invoice.exchangeRate,
      ) ?? undefined,
    ),
    cost.order.price,
    cost.order.currency,
    calculateMargin(cost.order.price, cost.order.currency, cost.currency, cost.invoices),
    cost.notes.map((n) => `${n.date}: ${n.text} (${n.author})`).join("\n"),
  ]);
}

export function costsToCsv(values: Omit<Cost, "files">[]) {
  const dataRows = orderBy(values, (r) => [r.provider.name, r.status], "asc").flatMap(costCsvRows);
  return [headers, ...dataRows];
}
